export default {
  name: "LivePropertyFeed",
  props: {
    feed: {
      type: Object,
      default: null
    },
    locationName: {
      type: String,
      default: "Live Property"
    },
    coordinates: {
      type: Object,
      default: null
    },
    selectedLocation: {
      type: Object,
      default: null
    }
  },
  data() {
    return ({
      image_failed: false,
      refresh_key: Date.now(),
      is_fullscreen: false
    });
  },
  mounted() {
    document.addEventListener("fullscreenchange", this.handle_fullscreen_change);
  },
  beforeUnmount() {
    document.removeEventListener("fullscreenchange", this.handle_fullscreen_change);
  },
  watch: {
    selectedLocation: {
      deep: true,
      handler() {
        this.refresh_feed();
      }
    },
    feed() {
      this.refresh_feed();
    }
  },
  computed: {
    stream_url() {
      return this.feed?.url || "";
    },
    camera_label() {
      return this.feed?.label || "Live camera";
    },
    selected_location_name() {
      return this.selectedLocation?.name || this.locationName;
    },
    selected_coordinates() {
      return this.selectedLocation?.coordinates || this.coordinates;
    },
    coordinate_label() {
      if (!this.selected_coordinates) return "Coordinates unavailable";

      const lat = Number(this.selected_coordinates.lat);
      const lng = Number(this.selected_coordinates.lng);

      if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return "Coordinates unavailable";
      }

      return `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
    },
    live_feed_src() {
      if (!this.stream_url) return "";
      const separator = this.stream_url.includes("?") ? "&" : "?";
      return `${this.stream_url}${separator}t=${this.refresh_key}`;
    }
  },
  methods: {
    async toggle_fullscreen() {
      const target = this.$refs.live_feed_card;
      if (!target) return;

      try {
        if (document.fullscreenElement) {
          await document.exitFullscreen();
          return;
        }

        await target.requestFullscreen();
      } catch (error) {
        console.warn("Unable to toggle live feed fullscreen.", error);
      }
    },
    handle_fullscreen_change() {
      this.is_fullscreen = document.fullscreenElement === this.$refs.live_feed_card;
    },
    refresh_feed() {
      this.image_failed = false;
      this.refresh_key = Date.now();
    },
    mark_feed_failed() {
      this.image_failed = true;
    },
    mark_feed_loaded() {
      this.image_failed = false;
    }
  }
};
